<template>
    <BaseInput :error="error" :required="required">
        <template slot="label">
            <span v-if="validator === FORM_VALIDATORS.color" :style="{ backgroundColor: value }" class="color-circle"></span> {{ label }}
        </template>
        <template slot="input">
            <div class="input-div" style="position:relative; left:-3em;">
                <textarea
                    :value="value"
                    :minlength="minLength || false"
                    :maxlength="maxLength || false"
                    @blur="blurListener"
                    @input="inputListener"
                    :disabled="disabled"
                    :rows="parseInt(counter) < 25 ? 2 : 2 + parseInt(counter) / 25"
                />
                <span class="counter" :class="{ counter__full: counterError }" v-if="counter">{{ counter }}</span>
            </div>
        </template>
    </BaseInput>
</template>

<script>
import FormValidator from "@/mixins/FormValidator";
import { isNotEmpty, MAX_LENGTH_NAME } from "@/utils/string";
import BaseInput from "@/components/ui/Form/BaseInput";

export default {
    data: () => ({
        localErrorMessage: undefined
    }),
    components: {
        BaseInput
    },
    props: {
        value: {
            required: true
        },
        label: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        errorMessage: {
            type: String,
            required: false
        },
        maxLength: {
            type: Number,
            required: false,
            default: MAX_LENGTH_NAME
        },
        minLength: {
            type: Number,
            required: false,
            default: undefined
        },
        validator: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mixins: [FormValidator],
    computed: {
        error() {
            return this.errorMessage || this.localErrorMessage;
        },
        counter() {
            const length = (this.value && this.value.length) || 0;
            return this.maxLength && `${length}/${this.maxLength}`; // Displays string like "13/34";
        },
        counterError() {
            const length = (this.value && this.value.length) || 0;
            return length < this.minLength || length > this.maxLength;
        }
    },
    methods: {
        inputListener($event) {
            this.$emit("input", $event.target.value.trim());
        },
        blurListener($event) {
            this.localErrorMessage = undefined;
            const value = $event.target.value.trim();

            // If the field is not required and is empty we can continue.
            const isEmpty = !isNotEmpty(value);
            if (!this.required && isEmpty) return true;

            const valueIsValid = this.validInput(value, this);
            if (valueIsValid !== true) {
                this.localErrorMessage = valueIsValid;
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

label {
    font-family: Roboto, sans-serif;
    font-weight: bold;
    font-size: 1.17em;
}
.input-div {
    display: grid;
    grid-template-columns: 1fr 50px;
    align-items: center;
    border: 1px solid #333333;
    @extend %primary-border-color;
    background-color: #fff;
    border-radius: 5px;
    width: 140%;
    overflow: hidden;
}
textarea {
    font-size: 16px;
    background-color: #fff;
    border: none;
}
.counter {
    background-color: #fff;
    color: #000;
    text-align: center;
    opacity: 0.3;
    font-family: "Roboto", sans-serif;
    &__full {
        opacity: 0.7;
        color: $error-color;
    }
}
.color-circle {
    display: inline-block;
    vertical-align: middle;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// TextareaInputBloc.vue?75d9e928